import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSessionMonitor } from './useSessionMonitor';

export const SessionMonitor: React.FC = () => {
  const { t } = useTranslation();
  const { minutesToExpiration, continueSession } = useSessionMonitor();

  return (
    <Dialog open={!!minutesToExpiration}>
      <DialogTitle>{t('sessionIsExpiring')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('sessionExpiresIn', { minutesToExpiration })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={continueSession} color="primary" autoFocus>
          {t('continueSession')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
